function readAuthCookie() {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(/(?:^|;\s*)authToken=([^;]+)/)
  return match ? decodeURIComponent(match[1]) : null
}

/** @type {string | null} */
let accessToken = readAuthCookie()
/** @type {null | (() => Promise<string | null>)} */
let refreshHandler = null
/** @type {Set<(token: string | null) => void>} */
const subscribers = new Set()

export function getAccessTokenState() {
  return accessToken
}

export function setAccessTokenState(token) {
  accessToken = token
}

export function getRefreshHandlerState() {
  return refreshHandler
}

export function setRefreshHandlerState(fn) {
  refreshHandler = fn
}

export function getAuthSubscribers() {
  return subscribers
}
